<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">事前仮予約</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-form class="static" v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <div required>
                <remote-autocomplete
                  :label="$t('app.labels.partner')"
                  :rules="[v=> !!v || $t('app.labels.partner') +' is required']"
                  key="partner"
                  url="companies/kv?type=PARTNER"
                  v-model="sa.partnerId"
                ></remote-autocomplete>
              </div>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <div required>
                <remote-autocomplete
                  :label="$t('app.labels.forwarder')"
                  :rules="[v=> !!v || $t('app.labels.forwarder') +'is required']"
                  key="forwarderId"
                  url="companies/forwarders/kv"
                  v-model="sa.forwarderId"
                ></remote-autocomplete>
              </div>
            </v-flex>
            <v-flex md3 xs12>
              <div required>
                <remote-autocomplete
                  :label="$t('app.labels.package.containerSize')"
                  :rules="[v=> !!v || $t('app.labels.package.containerSize') +'is required']"
                  url="container-types/kv"
                  v-model="sa.containerTypeCode"
                />
              </div>
            </v-flex>
            <v-flex>
              <div required>
                <remote-autocomplete
                  :rules="[v=> !!v || '最终納入場所 is required']"
                  label="最终納入場所"
                  url="warehouses/sjl-kv"
                  v-model="sa.finallyWarehouseId"
                ></remote-autocomplete>
              </div>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <div required>
                <date-picker
                  :rules="[v=> !!v || '納入予定日 is required']"
                  label="納入予定日"
                  v-model="sa.forecastDeliveryDate"
                ></date-picker>
              </div>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <div required>
                <v-text-field
                  :rules="[v=> /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) || `4桁の数の有効時間を入力してください`]"
                  label="時間"
                  v-model="sa.forecastDeliveryTime"
                />
              </div>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field label="INV NO" v-model="sa.invoiceNo"></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <date-picker :label="$t('app.labels.eta')" v-model="sa.eta" />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                key="loadingPortCode"
                url="ports/kv"
                v-model="sa.loadingPortCode"
              />
            </v-flex>

            <v-flex md3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                key="dischargePortCode"
                url="ports/kv"
                v-model="sa.dischargePortCode"
              />
            </v-flex>

            <v-flex md3 xs12>
              <v-text-field :label="$t('app.labels.package.containerNo')" v-model="sa.containerNo" />
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field :label="$t('app.labels.blNo')" v-model="sa.blNo"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      sa: {},
      valid: false,
      errors: {
        UP_TO_LIMIT: '受入上限本数を超えてしまうので、事前仮予約できません。'
      }
    }
  },
  methods: {
    save() {
      var time = this.$insert(this.sa.forecastDeliveryTime, 0, 2, ':')
      time = this.$insert(time, 0, 5, ':')
      time = time + '00'

      // this.sa.forecastDeliveryTime = time

      this.$http
        .post('/delivery-orders/booking-do', {
          ...this.sa,
          forecastDeliveryTime: time
        })
        .then(() => {
          this.$message('', 'save success')
          this.$router.push('/B0600')
        })
        .catch(res => {
          this.$showError(res)
        })
    },
    back() {
      this.$router.push('/B0600')
    }
  }
}
</script>
